import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchIndustryList } from "../Utils/slice";
import { RootState, AppDispatch } from "../../../../../store/app";
import { Link, useNavigate } from "react-router-dom";
import BreadcrumbComponent from "../../../CommonComponent/BreadcrumbComponent";
import { EnergyIndustriesBreadcrumb } from "../../../../../config/BreadcrumbConfig";
import { Col, Grid, Row, Skeleton } from "antd";

const EnergyIndustries = () => {
  const dispatch: AppDispatch = useDispatch();
  const industryList = useSelector(
    (state: RootState) => state.WEBPROFILE.industryList
  );
  const loading = useSelector(
    (state: RootState) => state.WEBPROFILE.appLoading
  );
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md; // Assuming 'md' is the breakpoint for mobile view

  useEffect(() => {
    dispatch(fetchIndustryList());
  }, [dispatch]);

  // Extract the data array from the API response
  const categories = industryList && industryList.data ? industryList.data : [];

  return (
    <div style={{ background: "#f5f6f7" }} className="all-careers-mobile">
      <section>
        <div className="container-fluid">
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <div className="career-index-header mobile-header">
                <BreadcrumbComponent
                  key={1}
                  items={EnergyIndustriesBreadcrumb.path}
                />
                <div
                  style={{
                    fontSize: 17,
                    color: "#555",
                    // marginLeft: 5,
                    marginTop: 10,
                  }}
                >
                  Begin exploring the industries powering the energy sector and discover where your career journey can take you. Each industry starts
                  with Awareness-level learning, then guides you toward 101 and 102 training to build your skills and prepare for in-demand careers.
                </div>
              </div>
            </Col>

            <Col span={24}>
              {loading ? (
                <Skeleton avatar paragraph={{ rows: 1 }} active />
              ) : (
                <div
                  style={{
                    marginBottom: isMobile ? 10 : 0,
                    // marginLeft: isMobile ? 7 : 0,
                    // marginRight: isMobile ? 7 : 0,
                    borderRadius: 16,
                    // paddingLeft: 10,
                    // paddingRight: 10,
                  }}
                // className="training-credentials-section"
                >
                  {categories &&
                    Array.isArray(categories) &&
                    categories.length > 0 ? (
                    categories.map((category: any, idx: number) =>
                      category.industries &&
                        Array.isArray(category.industries) &&
                        category.industries.length > 0 ? (
                        <div
                          className="energy-industries-section"
                          key={category.id || idx}
                          style={{ marginBottom: "24px" }}
                        >
                          <div className="energy-industries-section-title">
                            {category.name}
                          </div>
                          {category.description && (
                            <div className="energy-industries-section-desc">
                              {category.description}
                            </div>
                          )}
                          <Row
                            gutter={[24, 24]}
                            className="energy-industries-cards"
                          >
                            {category.industries.map((industry: any) => (
                              <Col
                                xs={24} // Full width on mobile
                                sm={24} // Full width on small tablets
                                md={12} // Two columns on medium devices
                                lg={8} // Three columns on large devices
                                xl={8} // Three columns on extra large devices
                                key={industry.id}
                              >
                                <Link
                                  className="energy-industries-card"
                                  key={industry.id}
                                  to={`/energy-industries-details/${btoa(industry.id)}`}
                                >
                                  <div className="energy-industries-card-title">
                                    {industry.industry_name}
                                  </div>
                                  {industry.description && (
                                    <div
                                      className="energy-industries-card-desc"
                                      dangerouslySetInnerHTML={{
                                        __html: industry.description,
                                      }}
                                    ></div>
                                  )}
                                </Link>
                              </Col>
                            ))}
                          </Row>
                        </div>
                      ) : null
                    )
                  ) : (
                    <div>No industry data found.</div>
                  )}
                </div>
              )}
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default EnergyIndustries;
